export default __webpack_public_path__ + "static/media/photo--sm--misc-25.d59617e8.jpg";